module.exports = __webpack_public_path__ + "img/tab11.79838593.jpg";